import EmptyState from "../store/emptyState";
import globalReducerHelper from "./globalReducerHelper";

const stateSwitcher = (state = EmptyState.stateSwitcher, action) => {
  if (!state) {
    return {};
  }

  const { type, payload } = action;

  switch (type) {
    default:
      return globalReducerHelper(
        state,
        type,
        payload && payload.stateSwitcher,
        EmptyState.stateSwitcher
      );
  }
};

export default stateSwitcher;
